import script from "./UserAgreement.vue?vue&type=script&setup=true&lang=js"
export * from "./UserAgreement.vue?vue&type=script&setup=true&lang=js"

import "./UserAgreement.vue?vue&type=style&index=0&id=498d0723&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-498d0723"]])

export default __exports__